import { Route } from 'config';

// navigation dropdown options
export const MY_ACCOUNT_DROPDOWN_OPTIONS = [
  {
    label: 'Subscription',
    value: Route.PROFILE,
  },
  {
    label: 'Account Settings',
    value: Route.ACCOUNT_SETTINGS,
  },
  {
    label: 'Payment Method',
    value: Route.PAYMENT_METHOD,
  },
  {
    label: 'Delivery Address',
    value: Route.DELIVERY_ADDRESS,
  },
  {
    label: 'Notification Preferences',
    value: Route.NOTIFICATION_PREFERENCES,
  },
];
